// theme/spacing-utils.js
import { spacing } from './spacing';
import { deviceMin } from './breakpoints';

/**
 * génère les utilitaires margin/padding + variantes responsive
 * ex. .m-4   .mr-4   .tablet\:mr-4   .laptop\:mr-4
 *  * ex. .p-4   .pr-4   .tablet\:pr-4   .laptop\:pr-4
 */
const directions = {
  '': '',        //   m-4   p-4
  t: '-top',      //  mt-4  pt-4
  r: '-right',    //  mr-4  pr-4
  b: '-bottom',   //  mb-4  pb-4
  l: '-left',     //  ml-4  pl-4
  x: '-inline',   //  mx-4  px-4   (RTL-friendly)
  y: '-block',    //  my-4  py-4
};

/* Gènère toutes les règles pour une base donnée (margin | padding) ------- */
const renderSpacing = (cssProp, util) =>
  Object.entries(spacing)                     // 0-5, 10, etc.
    .map(([key, val]) =>
      Object.entries(directions)              // '', t, r, …
        .map(([suf, prop]) => {
          // nom de la classe : m, mt, mr…  ou  laptop\:mr
          const className =
            suf === '' ? `.${util}-${key}` : `.${util}${suf}-${key}`;

          return `${className} { ${cssProp}${prop}:${val}; }`;
        })
        .join('')
    )
    .join('');                                // ← plus de flatMap

export const buildSpacingCSS = () => {
  /* 1. Mobile-first (pas de media-query) -------------------------------- */
  const globalCSS =
    renderSpacing('margin', 'm') +
    renderSpacing('padding', 'p');

  /* 2. Breakpoints : laptop:mr-4, tablet:py-2 … ------------------------- */
  const responsiveCSS = Object.entries(deviceMin)
    .map(([label, query]) => `
      @media ${query} {
        ${renderSpacing('margin', `${label}\\:m`)}
        ${renderSpacing('padding', `${label}\\:p`)}
      }`
    )
    .join('');

  return globalCSS + responsiveCSS;
};
